import { useCallback, useState } from 'react';

export type BulkDeleteModalState = {
  bulkDeleteModalOpen: boolean;
  bulkDeleteCount: number;
  bulkDeleteIds: string[];
  onOpenBulkDeleteModal: (count: number, ids: string[]) => void;
  onCloseBulkDeleteModal: () => void;
};

export const useBulkDeleteModal = (): BulkDeleteModalState => {
  const [bulkDeleteCount, setBulkDeleteCount] = useState<number>(0);
  const [bulkDeleteIds, setBulkDeleteIds] = useState<string[]>([]);
  const [bulkDeleteModalOpen, setBulkDeleteModalOpen] =
    useState<boolean>(false);

  const onOpenBulkDeleteModal = useCallback((count: number, ids: string[]) => {
    setBulkDeleteCount(count);
    setBulkDeleteIds(ids);
    setBulkDeleteModalOpen(true);
  }, []);

  const onCloseBulkDeleteModal = useCallback(() => {
    setBulkDeleteModalOpen(false);
    setBulkDeleteCount(0);
    setBulkDeleteIds([]);
  }, []);

  return {
    bulkDeleteModalOpen,
    bulkDeleteCount,
    bulkDeleteIds,
    onOpenBulkDeleteModal,
    onCloseBulkDeleteModal,
  };
};
